module.exports = __webpack_public_path__ + "static/media/a1.65eedac7.png";